import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';

import { HttpUtilsService } from '../../commons/http-uilis.service';
import { Paging } from '../../../model/paging/paging';
import { environment } from '../../../environment/environment';
import { AntennaList } from '../../../model/antenna/antenna-list';

@Injectable({
  providedIn: 'root'
})
export class AntennaService_Mock {
  private _url: string = `${environment.baseAPIURL}/settings`;

  constructor(private _http: HttpClient, private _httpUtils: HttpUtilsService) {}

  GETPaginatedAntennas(paging: Paging) {
    const allData = this.getMockAntennas();
    const start = (paging.pageIndex - 1) * paging.pageSize;
    const end = start + paging.pageSize;

    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 14,
      data: {
        count: allData.length,
        items: allData.slice(start, end)
      }
    });
  }

  GETAntennaDetails(antennaId: string) {
    const antenna = this.getMockAntennas().find((item) => item.antennaId === antennaId) ?? this.getMockAntennas()[0];

    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 9,
      data: antenna
    });
  }

  PUTAntenna(antennaId: string, body: AntennaList) {
    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 11,
      data: true
    });
  }

  DELETEAntenna(antennaId: string) {
    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 8,
      data: true
    });
  }

  POSTAntenna(body: AntennaList) {
    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 12,
      data: true
    });
  }

  private getMockAntennas() {
    return [
      {
        antennaId: 'antenna-main',
        name: 'Antenna Main',
        model: 'ANT2',
        length: 120,
        type: 'TYPE_L',
        longitudinalLoss: { freq24: 1.2, freq5: 2.1, freq6: 2.8 },
        couplingLoss: { freq24: 0.8, freq5: 1.5, freq6: 2.0 },
        tilt: { attenuation: 0.5, percentageOfLength: 10.0 },
        terminationOmni: {
          freq24: { gain: 2.5, attenuationFactor: 0.3 },
          freq5: { gain: 2.0, attenuationFactor: 0.2 },
          freq6: { gain: 1.8, attenuationFactor: 0.1 }
        },
        enabled: true
      },
      {
        antennaId: 'antenna-hallway',
        name: 'Antenna Hallway',
        model: 'OMNI',
        length: 95,
        type: 'TYPE_C',
        longitudinalLoss: { freq24: 1.0, freq5: 1.9, freq6: 2.6 },
        couplingLoss: { freq24: 0.7, freq5: 1.3, freq6: 1.9 },
        tilt: { attenuation: 0.4, percentageOfLength: 8.0 },
        terminationOmni: {
          freq24: { gain: 2.2, attenuationFactor: 0.28 },
          freq5: { gain: 1.9, attenuationFactor: 0.18 },
          freq6: { gain: 1.6, attenuationFactor: 0.1 }
        },
        enabled: true
      },
      {
        antennaId: 'antenna-corner',
        name: 'Antenna Corner',
        model: 'ANT5',
        length: 140,
        type: 'TYPE_L',
        longitudinalLoss: { freq24: 1.4, freq5: 2.4, freq6: 3.0 },
        couplingLoss: { freq24: 1.0, freq5: 1.8, freq6: 2.3 },
        tilt: { attenuation: 0.7, percentageOfLength: 12.0 },
        terminationOmni: {
          freq24: { gain: 2.7, attenuationFactor: 0.35 },
          freq5: { gain: 2.2, attenuationFactor: 0.24 },
          freq6: { gain: 1.9, attenuationFactor: 0.14 }
        },
        enabled: false
      },
      {
        antennaId: 'antenna-warehouse',
        name: 'Antenna Warehouse',
        model: 'OMNI',
        length: 160,
        type: 'TYPE_L',
        longitudinalLoss: { freq24: 1.6, freq5: 2.7, freq6: 3.4 },
        couplingLoss: { freq24: 1.1, freq5: 1.9, freq6: 2.5 },
        tilt: { attenuation: 0.9, percentageOfLength: 15.0 },
        terminationOmni: {
          freq24: { gain: 2.9, attenuationFactor: 0.4 },
          freq5: { gain: 2.4, attenuationFactor: 0.28 },
          freq6: { gain: 2.1, attenuationFactor: 0.18 }
        },
        enabled: true
      },
      {
        antennaId: 'antenna-lab',
        name: 'Antenna Lab',
        model: 'ANT2',
        length: 110,
        type: 'TYPE_C',
        longitudinalLoss: { freq24: 1.1, freq5: 2.0, freq6: 2.7 },
        couplingLoss: { freq24: 0.75, freq5: 1.35, freq6: 1.95 },
        tilt: { attenuation: 0.45, percentageOfLength: 9.5 },
        terminationOmni: {
          freq24: { gain: 2.4, attenuationFactor: 0.29 },
          freq5: { gain: 2.0, attenuationFactor: 0.2 },
          freq6: { gain: 1.7, attenuationFactor: 0.11 }
        },
        enabled: false
      },
      {
        antennaId: 'antenna-backup',
        name: 'Antenna Backup',
        model: 'ANT5',
        length: 130,
        type: 'TYPE_C',
        longitudinalLoss: { freq24: 1.3, freq5: 2.2, freq6: 2.9 },
        couplingLoss: { freq24: 0.9, freq5: 1.6, freq6: 2.1 },
        tilt: { attenuation: 0.6, percentageOfLength: 11.0 },
        terminationOmni: {
          freq24: { gain: 2.6, attenuationFactor: 0.32 },
          freq5: { gain: 2.1, attenuationFactor: 0.22 },
          freq6: { gain: 1.85, attenuationFactor: 0.13 }
        },
        enabled: true
      }
    ];
  }
}
